module.exports = __webpack_public_path__ + "media/images/icons/close-self-7301154bb8f0a07f88dc0adbe450e029.svg";